import { render } from "./SalesGraph.vue?vue&type=template&id=0161f185&scoped=true"
import script from "./SalesGraph.vue?vue&type=script&lang=js"
export * from "./SalesGraph.vue?vue&type=script&lang=js"

import "./SalesGraph.vue?vue&type=style&index=0&id=0161f185&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0161f185"]])

export default __exports__